import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getArticlesCategoryList } from "../api/getArticlesCategoryList";
import { ArticleBrandId, ArticleCategory } from "../types";

export const QUERY_KEY = "article-list-by-category";

type Params = {
  brandId: ArticleBrandId;
  categoryId: ArticleCategory;
};

export const useArticleCategoryListQuery = ({
  brandId,
  categoryId,
}: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY, { brandId, categoryId }],
    queryFn: async () => {
      const data = await getArticlesCategoryList(brandId, categoryId);

      return data;
    },
  });
};

export const invalidateArticleCategoryListQuery = ({
  brandId,
  categoryId,
}: Params) => {
  return queryClient.invalidateQueries({
    queryKey: [QUERY_KEY, { brandId, categoryId }],
  });
};
